import { render } from "./LeaveInboxView.vue?vue&type=template&id=20baf92a&scoped=true"
import script from "./LeaveInboxView.vue?vue&type=script&lang=js"
export * from "./LeaveInboxView.vue?vue&type=script&lang=js"

import "./LeaveInboxView.vue?vue&type=style&index=0&id=20baf92a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20baf92a"]])

export default __exports__